import { useContext, useState, useEffect, useCallback } from "react";
import { StyleSheet, View, Text } from "react-native";
import { ScrollView, RefreshControl } from "react-native-gesture-handler";
import SafeAreaView from "../components/SafeAreaView";
import SensorMainItem from "../components/SensorMainItem";

import { AuthContext } from "../context/AuthContext";
import * as Config from "../config";
import axios from "axios";
import qs from "qs";
import { MeasuringPointMainSubitem } from "../components/SensorMainSubitem";
import PageHeader from "../components/PageHeader";
import { EventRegister } from "react-native-event-listeners";
import { getSchemeStyle } from "../context/helper";
import ActivityScreen from "./activityscreen";

const MeasuringPointScreen = ({ navigation }) => {
  const schemeStyles = getSchemeStyle();

  const { userToken, useFirm } = useContext(AuthContext);

  const [dataLoaded, setDataLoaded] = useState(false);
  const [sensorData, setSensorData] = useState([]);
  const [stickeIdx, setStickyIdx] = useState([]);

  const [refreshing, setRefreshing] = useState(false);

  const changeSensorData = (data) => {
    let newdata = [];
    let idx = [];
    let id = -1;
    let lastBranchID = -1;
    data.forEach((item) => {
      if (item.branchid !== lastBranchID) {
        if (lastBranchID !== -1) {
          id++;
          newdata.push({
            standortID: lastBranchID,
            standortName: null,
            sensor: null,
          });
        }
        id++;
        idx = [...idx, id];
        newdata.push({
          standortID: item.branchid,
          standortName: item.branchname,
          sensor: null,
        });
        lastBranchID = item.branchid;
      }
      newdata.push({
        standortID: item.branchid,
        standortName: item.branchname,
        sensor: item,
      });
      id++;
    });
    newdata.push({
      standortID: lastBranchID,
      standortName: null,
      sensor: null,
    });
    setSensorData(newdata);
    setStickyIdx(idx);
  };

  const loadData = async (dorefresh) => {
    dorefresh ? setRefreshing(true) : setDataLoaded(false);

    const url = `${Config.BASE_URL}/getdata`;
    let data = {
      action: "measuringpointsforfirmadmin",
      firmid: useFirm.current,
    };
    let options = {
      method: "POST",
      headers: {
        "content-type": "application/x-www-form-urlencoded",
        Authorization: "Bearer " + userToken,
      },
      data: qs.stringify(data),
      url,
    };
    await axios(options)
      .then((res) => {
        let _sensordata = res.data;
        //console.log(_sensordata.data[0].sensoren[0]);
        if (_sensordata && _sensordata.result == "OK") {
          changeSensorData(_sensordata.data);
        }
      })
      .catch((e) => {
        console.log(`MeasuringPoints error ${e}`);
      });
    dorefresh ? setRefreshing(false) : setDataLoaded(true);
  };
  const sensorActivate = async (sensorid, active) => {
    return new Promise(async (resolve, reject) => {
      const url = `${Config.BASE_URL}/getdata`;
      let data = {
        action: "sensoractivate",
        firmid: useFirm.current,
        sensorid: sensorid,
        active: active ? 1 : 0,
      };
      let options = {
        method: "POST",
        headers: {
          "content-type": "application/x-www-form-urlencoded",
          Authorization: "Bearer " + userToken,
        },
        data: qs.stringify(data),
        url,
      };
      await axios(options)
        .then((res) => {
          let _sensordata = res.data;
          //console.log(_sensordata);
          if (_sensordata && _sensordata.result == "OK") {
            resolve({ result: "OK", reason: "" });
          } else
            reject({
              result: "Failed",
              code: 500,
              reason: "No Data",
            });
        })
        .catch((e) => {
          reject({
            result: "Failed",
            code: e.response ? e.response.status : 500,
            reason: e.response ? e.response.data : `${e}`,
          });
        });
    });
  };

  const onRefresh = useCallback(() => {
    loadData(true);
  }, [sensorData]);

  useEffect(() => {
    loadData(false);
  }, []);
  useEffect(() => {
    const emitBranchChange = EventRegister.addEventListener(
      Config.Events.BRANCH_CHANGE,
      (msg) => {
        let changedData = [...sensorData];
        changedData.forEach((item) => {
          if (item.standortID === msg.branchid && item.standortName) {
            item.standortName = msg.branchname;
            if (item.sensor) item.sensor.branchname = msg.branchname;
          }
        });

        //console.log(changedData.filter((item)=> item.standortID===msg.branchid));
        setSensorData(changedData);
      }
    );
    const emitSensorActivate = EventRegister.addEventListener(
      Config.Events.SENSOR_ACTIVATE,
      (msg) => {
        if (!msg.result) {
          let changedData = [...sensorData];
          changedData.forEach((item) => {
            if (item.sensor && item.sensor.id === msg.sensorid)
              item.sensor.isactive = msg.active;
          });

          setSensorData(changedData);
        }
      }
    );
    const emitSensorChange = EventRegister.addEventListener(
      Config.Events.SENSOR_CHANGE,
      (msg) => {
        let changedData = [...sensorData];
        changedData.forEach((item) => {
          if (item.sensor && item.sensor.id === msg.sensorID) {
            item.sensor.name = msg.sensorName;
            item.sensor.orderid = msg.sensorSortID;
            item.sensor.minvalue = msg.sensorMin;
            item.sensor.maxvalue = msg.sensorMax;
            item.sensor.offlinesensor = msg.sensorOffline == 1;
            item.sensor.errsendalways = msg.sensorErrorAlways == 1;
            item.sensor.errsendalways = msg.sensorErrorAlways == 1;
            item.sensor.isactive = msg.sensorActive == 1;
          }
        });
        setSensorData(changedData);
      }
    );
    return () => {
      EventRegister.removeEventListener(emitBranchChange);
      EventRegister.removeEventListener(emitSensorActivate);
      EventRegister.removeEventListener(emitSensorChange);
    };
  }, [sensorData]);

  if (!dataLoaded) {
    return (
      <ActivityScreen />
    );
  }

  return (
    <SafeAreaView style={[styles.mainContainer,schemeStyles.Background]}>
      <PageHeader navigation={navigation} />
      <ScrollView
        style={styles.scrollContainer}
        stickyHeaderIndices={stickeIdx}
        refreshControl={
          <RefreshControl refreshing={refreshing} onRefresh={onRefresh} />
        }
      >
        {sensorData.length > 0 ? (
          sensorData.map((item) =>
            item.sensor === null ? (
              item.standortName !== null ? (
                <SensorMainItem
                  key={"B_" + item.standortID}
                  item={item}
                  onPress={(itm) => {
                    navigation.navigate("ChangeBranch", {
                      branchid: itm.standortID,
                    });
                  }}
                  menuStyle={"kebap"}
                />
              ) : (
                <MeasuringPointMainSubitem key={"E_" + item.standortID} />
              )
            ) : (
              <MeasuringPointMainSubitem
                key={item.sensor.id}
                item={item.sensor}
                onPress={() => {
                  navigation.navigate("ChangeMeasuringPoint", {
                    branchid: item.standortID,
                    sensorid: item.sensor.id,
                  });
                }}
                onActivate={(sensorid, active) => {
                  sensorActivate(sensorid, active)
                    .then((res) => {
                      EventRegister.emit(Config.Events.SENSOR_ACTIVATE, {
                        result: true,
                        sensorid: sensorid,
                        active: active,
                      });
                    })
                    .catch((e) => {
                      EventRegister.emit(Config.Events.SENSOR_ACTIVATE, {
                        result: false,
                        sensorid: sensorid,
                        active: !active,
                      });
                    });
                }}
              />
            )
          )
        ) : (
          <View style={styles.noData}>
            <Text>Keine Daten</Text>
          </View>
        )}
      </ScrollView>
    </SafeAreaView>
  );
};

export default MeasuringPointScreen;

const styles = StyleSheet.create({
  mainContainer: {
    flex: 1,
    paddingVertical: 20,
  },
  scrollContainer: {
    paddingHorizontal: 10,
  },
  noData: {
    flex: 1,
    alignItems: "center",
  },
});
